import { AllAssetsCatagoryResponseModel, AssetsCatagoryResponse, AssetsCatagoryResponseModel, AssetsCatDropDownResponseModel } from '@gtpl/shared-models/asset-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { AssetsCatagory } from './assets-catagory-entity';
import { AssetsCatagoryService } from './assets-catagory.service';
import { AssetsRequest } from './dto/assets-catagory-active-inactive';
import { AssetsCatagoryDTO } from './dto/assets-catagory-dto';
import { assetsCatagoryByIdReq } from './dto/assets-catagory-id-request';
import { AssetsClassificationByIdDto } from './dto/assets-classification-id-request';

@ApiTags('assets-catagory')
@Controller('assets-catagory')
export class AssetsController {
    constructor(private assetsCatagoryService: AssetsCatagoryService, private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

    @Post('/createAssetsCatagory')
    async createAssetsCatagory(@Body() assetsCatagoryDTO: AssetsCatagoryDTO): Promise<AssetsCatagoryResponseModel> {
        try {
            return await this.assetsCatagoryService.createAssetsCatagory(assetsCatagoryDTO, false);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AssetsCatagoryResponseModel, error);
        }
    }

    @Post('/updateAssetsClassification')
    async updateAssetsClassification(@Body() assetsCatagoryDTO: AssetsCatagoryDTO): Promise<AssetsCatagoryResponseModel> {
        try {
            return await this.assetsCatagoryService.createAssetsCatagory(assetsCatagoryDTO, true);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AssetsCatagoryResponseModel, error);
        }
    }

    @Post('getRecordByAssetsCatagoryId')
    async getRecordByAssetsCatagoryId(@Body() id: assetsCatagoryByIdReq): Promise<AssetsCatagoryResponseModel> {
        try {
            return await this.assetsCatagoryService.getRecordByAssetsCatagoryId(id.assetsCatagoryId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AssetsCatagoryResponseModel, error);
        }
    }

    @Post('getAllAssetsCatagory')
    async getAllAssetsCatagory(): Promise<AllAssetsCatagoryResponseModel> {
        try {
            return await this.assetsCatagoryService.getAllAssetsCatagory();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllAssetsCatagoryResponseModel, error);
        }
    }

    @Post('activateorDeactivateAssets')
    async activateorDeactivateAssets(@Body() AssetsCatagoryAct: AssetsRequest): Promise<AssetsCatagoryResponse> {
        try {
            return await this.assetsCatagoryService.activateorDeactivateAssets(AssetsCatagoryAct);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AssetsCatagoryResponse, error);
        }
    }

    @Post('/getAllAssetsCatagoryDropDown')
    async getAllAssetsCatagoryDropDown(): Promise<AssetsCatDropDownResponseModel> {
        try {
            return await this.assetsCatagoryService.getAllAssetsCatagoryDropDown();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AssetsCatDropDownResponseModel, error);
        }
    }

    @Post('/getAssetsCatagoryForAssetsClassificationId')
    async getAssetsCatagoryForAssetsClassificationId(@Body() assetsClassificationIdReq: AssetsClassificationByIdDto): Promise<AssetsCatDropDownResponseModel> {
        try {
            return await this.assetsCatagoryService.getAssetsCatagoryForAssetsClassificationId(assetsClassificationIdReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AssetsCatDropDownResponseModel, error);
        }
    }
}
